import React from 'react';
import { Button } from '@dxb-web-ui-framework/design-system';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { TableGridAction } from '../../types';

const renderTableGridActions = (actionsConfig?: TableGridAction[], classes?: GenericObject) => {
  if (actionsConfig) {
    return actionsConfig.map((action, index) => (
      <>
        {action.Component ? (
          <action.Component keyIndex={index} />
        ) : (
          <Button
            key={index}
            data-testid={action.dataTestId}
            disabled={action.disabled}
            fullWidth={action.fullWidth}
            variant={action.variant}
            size={action.size}
            color={action.color}
            isIconButton={action.isIconButton}
            onClick={action.onClick}
            classes={classes || {}}
            title={action.title}>
            {action.isIconButton ? action.icon : action.text}
          </Button>
        )}
      </>
    ));
  }

  return null;
};

export { renderTableGridActions };
